import Model from './Model'

export default class DeletedAccount extends Model {
  resource() {
    return 'users/deleted-accounts'
  }
}
